var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g2, _g3, _path39, _g4, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g5, _path57, _path58, _g6, _path59, _path60, _path61, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRhapsodyGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1161,
    height: 1161,
    viewBox: "0 0 1161 1161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1116 580.5C1116 876.249 876.248 1116 580.5 1116C284.752 1116 45 876.249 45 580.5C45 284.752 284.752 45 580.5 45C876.248 45 1116 284.752 1116 580.5Z",
    fill: "#D9DFE6",
    stroke: "#1A81F4",
    strokeWidth: 90
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M783.301 570.601H963.996C966.351 570.601 968.219 572.469 968.219 574.824V668.704C968.219 671.059 966.351 672.927 963.996 672.927H783.301C780.946 672.927 779.078 671.059 779.078 668.704V574.824C778.996 572.469 780.946 570.601 783.301 570.601Z",
    fill: "#7340E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_107_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M992.987 611.529H906.497C902.842 611.529 899.838 608.524 899.838 604.87V499.457C899.838 495.803 902.842 492.798 906.497 492.798H971.304C974.633 492.798 977.882 494.097 980.237 496.534L989.252 505.548C991.607 507.903 992.987 511.152 992.987 514.482V611.529Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M913.886 580.019H972.196",
    stroke: "#28213A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M913.886 594.719H953.355",
    stroke: "#28213A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M927.124 535.841C934.435 535.841 940.361 529.914 940.361 522.604C940.361 515.293 934.435 509.366 927.124 509.366C919.813 509.366 913.886 515.293 913.886 522.604C913.886 529.914 919.813 535.841 927.124 535.841Z",
    fill: "#7340E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M570.282 376.26L660.995 383.326",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M692.18 259.481V350.519",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M605.853 295.293L670.254 359.612",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M579.46 334.843L663.514 369.682",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M645.562 268.738L680.321 352.873",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M570.117 390.229H661.074",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M570.12 398.348H661.077",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M570.12 406.553H661.077",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M605.853 295.293L670.254 359.612",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M572.475 357.908L661.726 375.531",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M589.612 315.431L666.113 364.727",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M623.475 280.674L674.72 355.876",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M667.98 261.914L686.009 351.085",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M814.404 381.619H723.366",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M778.671 295.293L714.271 359.612",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M805.065 334.843L721.011 369.682",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M738.957 268.738L704.198 352.873",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M814.404 381.619H723.366",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M814.404 397.943H723.366",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M814.404 414.266H723.366",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M814.404 430.674H723.366",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M814.404 446.995H723.366",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M814.404 463.318H723.366",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M814.404 479.642H723.366",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M814.404 496.047H723.366",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M778.671 295.293L714.271 359.612",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M812.049 357.908L722.798 375.531",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M794.913 315.431L718.412 364.727",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M761.047 280.674L709.802 355.876",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M716.542 261.914L698.432 351.085",
    stroke: "#3782F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M391.374 419.87H684.385C690.882 419.87 696.242 425.149 696.242 431.727V515.699C696.242 522.196 690.963 527.556 684.385 527.556H391.374C384.877 527.556 379.517 522.278 379.517 515.699V431.727C379.598 425.149 384.877 419.87 391.374 419.87Z",
    fill: "#1A81F4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M230.331 351.085H345.408C347.357 351.085 348.981 352.628 348.981 354.658V392.34C348.981 394.289 347.438 395.913 345.408 395.913H230.331C228.382 395.913 226.839 394.37 226.839 392.34V354.577C226.758 352.628 228.382 351.085 230.331 351.085Z",
    fill: "#23C5BF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M777.939 755.355H883.271C885.463 755.355 887.25 757.142 887.25 759.335V808.386C887.25 810.579 885.463 812.366 883.271 812.366H777.939C775.747 812.366 773.96 810.579 773.96 808.386V759.335C773.96 757.061 775.747 755.355 777.939 755.355Z",
    fill: "#23C5BF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_107_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.667 483.298H834.625C843.395 483.298 850.542 490.445 850.542 499.216V639.712C850.542 648.483 843.395 655.629 834.625 655.629H322.667C313.896 655.629 306.75 648.483 306.75 639.712V499.216C306.75 490.445 313.896 483.298 322.667 483.298Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_107_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.869 376.505H454.066C459.02 376.505 463 380.484 463 385.438V444.479C463 449.433 459.02 453.412 454.066 453.412H263.869C258.915 453.412 254.854 449.433 254.854 444.479V385.438C254.936 380.484 258.915 376.505 263.869 376.505Z",
    fill: "white"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M204.1 675.279H300.417C304.558 675.279 307.888 678.609 307.888 682.751V733.427C307.888 737.569 304.558 740.898 300.417 740.898H204.1C199.958 740.898 196.628 737.569 196.628 733.427V682.751C196.628 678.69 199.958 675.279 204.1 675.279Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_107_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760.804 717.591H827.722C831.864 717.591 835.194 720.921 835.194 725.063V825.603C835.194 829.745 831.864 833.074 827.722 833.074H760.804C756.662 833.074 753.333 829.745 753.333 825.603V725.063C753.333 720.921 756.662 717.591 760.804 717.591Z",
    fill: "white"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M711.506 524.553L750.325 563.372C754.305 567.352 754.305 573.767 750.325 577.747L711.506 616.566",
    stroke: "#050F1A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M445.863 524.553L407.044 563.372C403.064 567.352 403.064 573.767 407.044 577.747L445.863 616.566",
    stroke: "#050F1A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M376 698L368.571 706.438C367.81 707.303 367.81 708.697 368.571 709.562L376 718",
    stroke: "#050F1A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M669 759L676.429 750.984C677.19 750.162 677.19 748.838 676.429 748.016L669 740",
    stroke: "#050F1A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M607 850L615.016 857.429C615.838 858.19 617.162 858.19 617.984 857.429L626 850",
    stroke: "#050F1A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M674.232 592.607C686.387 592.607 696.24 582.753 696.24 570.598C696.24 558.444 686.387 548.59 674.232 548.59C662.077 548.59 652.223 558.444 652.223 570.598C652.223 582.753 662.077 592.607 674.232 592.607Z",
    fill: "#1A81F4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M579.054 592.607C591.209 592.607 601.063 582.753 601.063 570.598C601.063 558.444 591.209 548.59 579.054 548.59C566.899 548.59 557.046 558.444 557.046 570.598C557.046 582.753 566.899 592.607 579.054 592.607Z",
    fill: "#23C5BF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M483.873 592.607C496.028 592.607 505.881 582.753 505.881 570.598C505.881 558.444 496.028 548.59 483.873 548.59C471.718 548.59 461.865 558.444 461.865 570.598C461.865 582.753 471.718 592.607 483.873 592.607Z",
    fill: "#FA7E2E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M351.499 750.32H420.853C422.802 750.32 424.427 751.863 424.427 753.812V855.733C424.427 857.682 422.883 859.225 420.853 859.225H351.499C349.55 859.225 347.925 857.682 347.925 855.733V753.812C348.007 751.863 349.55 750.32 351.499 750.32Z",
    fill: "#FA7E2E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M273.533 415.242H443.59",
    stroke: "#050F1A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M320.474 427.262C327.426 427.262 333.061 421.626 333.061 414.674C333.061 407.722 327.426 402.086 320.474 402.086C313.521 402.086 307.886 407.722 307.886 414.674C307.886 421.626 313.521 427.262 320.474 427.262Z",
    fill: "#FA7E2E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M672.444 749.914H613.728C604.389 749.914 596.755 742.28 596.755 732.941V670.652",
    stroke: "#050F1A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M371.964 708.171H539.91C550.548 708.171 559.157 699.563 559.157 688.924V670.652",
    stroke: "#050F1A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M577.914 670.652V778.582C577.914 789.221 586.522 797.91 597.242 797.91C607.881 797.91 616.571 806.519 616.571 817.239V856.707",
    stroke: "#050F1A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M351.227 709.643C352.06 704.508 348.572 699.669 343.437 698.835C338.301 698.002 333.462 701.489 332.629 706.625C331.795 711.761 335.283 716.6 340.418 717.433C345.554 718.267 350.393 714.779 351.227 709.643Z",
    fill: "#1A81F4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M617.628 884.89C621.306 884.89 624.287 881.908 624.287 878.231C624.287 874.553 621.306 871.571 617.628 871.571C613.95 871.571 610.969 874.553 610.969 878.231C610.969 881.908 613.95 884.89 617.628 884.89Z",
    fill: "#23C5BF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M706.96 759.496C712.836 759.496 717.599 754.733 717.599 748.858C717.599 742.982 712.836 738.219 706.96 738.219C701.085 738.219 696.322 742.982 696.322 748.858C696.322 754.733 701.085 759.496 706.96 759.496Z",
    fill: "#FA7E2E"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_107_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.035 775.335H490.936C499.22 775.335 505.879 781.994 505.879 790.278V819.27C505.879 827.554 499.22 834.213 490.936 834.213H401.035C392.751 834.213 386.092 827.554 386.092 819.27V790.278C386.173 782.076 392.833 775.335 401.035 775.335Z",
    fill: "white"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M475.183 823.899C485.723 823.899 494.268 815.354 494.268 804.814C494.268 794.274 485.723 785.729 475.183 785.729C464.643 785.729 456.098 794.274 456.098 804.814C456.098 815.354 464.643 823.899 475.183 823.899Z",
    fill: "#23C5BF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M786.304 795.15V783.374H774.528C773.229 783.374 772.173 782.319 772.173 781.019V769.65C772.173 768.35 773.229 767.294 774.528 767.294H786.304V755.519C786.304 754.219 787.36 753.164 788.659 753.164H800.029C801.328 753.164 802.384 754.219 802.384 755.519V767.294H814.159C815.459 767.294 816.515 768.35 816.515 769.65V781.019C816.515 782.319 815.459 783.374 814.159 783.374H802.384V795.15C802.384 796.449 801.328 797.505 800.029 797.505H788.659C787.278 797.505 786.304 796.449 786.304 795.15Z",
    fill: "#FA7E2E"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_107_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.519 721.896C241.417 721.896 264.033 699.28 264.033 671.382C264.033 643.484 241.417 620.869 213.519 620.869C185.621 620.869 163.006 643.484 163.006 671.382C163.006 699.28 185.621 721.896 213.519 721.896Z",
    fill: "white"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M189.399 675.12L205.479 691.281L237.639 659.04",
    stroke: "#050F1A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M438.311 286.764H532.354C540.556 286.764 547.297 293.424 547.297 301.707V329.4C547.297 337.603 540.638 344.343 532.354 344.343H438.311V286.764Z",
    fill: "#7340E4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M438.312 344.262C454.189 344.262 467.061 331.391 467.061 315.513C467.061 299.636 454.189 286.764 438.312 286.764C422.434 286.764 409.563 299.636 409.563 315.513C409.563 331.391 422.434 344.262 438.312 344.262Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_107_70",
    x: 878.12,
    y: 492.798,
    width: 136.585,
    height: 162.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21.7176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8588
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_107_70",
    x: 285.032,
    y: 439.863,
    width: 587.228,
    height: 215.766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -21.7176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8588
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_107_70",
    x: 233.137,
    y: 376.505,
    width: 251.58,
    height: 120.343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21.7176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8588
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_107_70",
    x: 731.615,
    y: 717.591,
    width: 125.296,
    height: 158.918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21.7176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8588
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_107_70",
    x: 364.374,
    y: 775.335,
    width: 163.222,
    height: 102.314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21.7176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8588
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_107_70",
    x: 141.288,
    y: 620.869,
    width: 144.462,
    height: 144.462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21.7176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8588
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_70",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhapsodyGraphic);
export default __webpack_public_path__ + "static/media/rhapsody-graphic.64b2a194e7dc065c840f11716661d47c.svg";
export { ForwardRef as ReactComponent };